export interface IExceptionalBoundaries {
  [key: string]: [number, number];
}

export const exceptionalBoundaries: IExceptionalBoundaries = {
  USA: [-85.299591, 35.116386],
};
